import { render, staticRenderFns } from "./AddNewButton.vue?vue&type=template&id=9b307584&scoped=true"
import script from "./AddNewButton.vue?vue&type=script&lang=js"
export * from "./AddNewButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b307584",
  null
  
)

export default component.exports